const toast_messages = {
  ErrorCountry: "Error While Fetching Countries",
  Signup: "Error While Signup",
}
export default toast_messages
